import { useKeycloak } from "@react-keycloak/web";
import PropTypes from "prop-types";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import User from "../../../../models/user";
export default function Micuenta({ setToken }) {
    // Retrieve user data from localStorage
    const { keycloak } = useKeycloak()
    const userData = new User(keycloak.token, keycloak.tokenParsed)

    return (
        <div className="content pt-3">
            <ToastContainer />
            <h1>Mi cuenta</h1>
            <p className="mb-2">Aquí aparecen los datos de tu cuenta y puedes cambiar las credenciales</p>

            <fieldset className="export-fieldset">
                <legend>Mis datos</legend>
                <div className="flex flex-row mb-4 space-x-2" style={{ paddingTop: "1em" }}>
                    <label>Nombre:</label>
                    <span style={{ marginRight: "1rem" }}> {userData.name}</span>
                    <label>Email:</label>
                    <span style={{ marginRight: "1rem" }}> {userData.email}</span>
                </div>
            </fieldset>
        </div>
    );
}

Micuenta.propTypes = {
    setToken: PropTypes.func.isRequired,
};
